import { useTheme } from '@chakra-ui/react';
var useModalPaddings = function (isMobile) {
    var theme = useTheme();
    var mobileBoxPadding = {
        pt: theme.size.container.mobile.y2,
        px: theme.size.container.mobile.x,
        pb: theme.size.container.mobile.x,
    };
    var deskBoxPadding = {
        pt: theme.size.container.desktop.y2,
        px: theme.size.container.desktop.x,
        pb: theme.size.container.desktop.x,
    };
    return isMobile ? mobileBoxPadding : deskBoxPadding;
};
export default useModalPaddings;
//# sourceMappingURL=useModalPaddings.js.map